import { render } from "./QuanLyThietBi.vue?vue&type=template&id=6ca37170&scoped=true"
import script from "./QuanLyThietBi.vue?vue&type=script&lang=js"
export * from "./QuanLyThietBi.vue?vue&type=script&lang=js"

import "./QuanLyThietBi.vue?vue&type=style&index=0&id=6ca37170&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca37170"]])

export default __exports__